
    export default {
        async asyncData({ params, $axios }) {
            var slug = params.slug;

            var author, educations;
            var loading = true;

            const result = await $axios.get(`author?slug=${slug}`)
            author = result.data.data.author;
            educations = result.data.data.educations;
            loading = false;

            return { slug, author, educations, loading }
        },
        head() {
            return {
                title: this.author.author_name,
                meta: [
                    {
                        hid: 'og-title',
                        property: 'og:title',
                        content: this.author.author_name,
                    },
                    {
                        hid: 'og-url',
                        property: 'og:url',
                        content: 'https://nod.ba/',
                    },
                    {
                        hid: 'og-image',
                        property: 'og:image',
                        content: this.$axios.defaults.baseURL + '/image?imagePath=' + this.author.avatar
                    },
                    {
                        hid: 'description',
                        property: 'description',
                        content: this.author.description
                    },
                    {
                        hid: 'og-description',
                        property: 'og:description',
                        content: this.author.description
                    },
                    // other meta
                ],
            };
        },
        data(){
            return {
                // author:     null,
                // educations: null,
                // loading:    true,
                search: ''
            }
        },
        computed: {
            filtered_educations(){
                return this.educations.filter(education => {
                    return education.title.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        },  
        created(){
           this.fetchAuthorEducations();
        },
        mounted() {
            //console.log('Component mounted.')
        },
        methods: {
            async fetchAuthorEducations(){
                const result = await this.$axios.get(`author?slug=${this.slug}`)
                this.author = result.data.data.author;
                this.educations = result.data.data.educations;
                this.loading = false;
                // .then(response => {
                //     // console.log(response)
                //     this.author = response.data.data.author;
                //     this.educations = response.data.data.educations;
                //     this.loading = false;
                // })
            }
        }
    }
